import { useState, useEffect } from 'react';

let isFlagEmojiFontRequested = false;
const useFlagEmojiFont = (mode, useIsFlagEmojiSupported) => {
    const [isRequested, setIsRequested] = useState(isFlagEmojiFontRequested);
    useEffect(() => {
        if (useIsFlagEmojiSupported || isRequested) {
            return;
        }
        setIsRequested(true);
        isFlagEmojiFontRequested = true;
        (mode === 'max' ? import('./loadFont.js') : import('./loadFont.ru_by_kz_uz.js'))
            .then(({ loadFont }) => loadFont())
            .catch(() => void 0);
    }, [useIsFlagEmojiSupported, isRequested, setIsRequested, mode]);
};

export { useFlagEmojiFont };
//# sourceMappingURL=useFlagEmojiFont.js.map
